import { ColorEnum } from '@/constants/color'
import { createStyleSheet } from 'react-native-unistyles'

export const stylesheet = createStyleSheet({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 4,
        borderWidth: 1,
        borderColor: ColorEnum.GRAY_300,
        padding: 8,
        gap: 8,
        variants: {
            disabled: {
                true: {
                    backgroundColor: ColorEnum.GRAY_200,
                },
                false: {
                    backgroundColor: ColorEnum.WHITE,
                },
            },
        },
    },
    label: {
        variants: {
            checked: {
                true: {
                    color: ColorEnum.BRICK_600,
                },
                false: {
                    color: ColorEnum.JET_500,
                },
            },
            disabled: {
                true: {
                    color: ColorEnum.GRAY_300,
                },
            },
        },
    },
})
